import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";
import ToolbarContainer from "../containers/auth/ToolbarContainer";
import NavBarContainer from "../containers/auth/NavBarContainer";
import Footer from "../components/Footer";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  main: {
    padding: 0,
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  content: {
    overflowX: "scroll",
    padding: 0,
    backgroundColor: "#F4F5F7",
    minHeight: "calc(100vh - 64px)",
  },
  footer: {
    padding: 0,
    marginTop: "auto",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[800],
  },
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <ToolbarContainer onMobileNavOpen={() => setMobileNavOpen(true)} />
      <Container component="main" className={classes.main} maxWidth={false}>
        <NavBarContainer
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
        />
        <Container className={classes.content} maxWidth={false}>
          {children}
        </Container>
      </Container>
      <footer className={classes.footer}>
        <Footer />
      </footer>
    </div>
  );
};

export default DashboardLayout;
